<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>掌柜助手</h3>
          <p>飞单服务稳定运行，告别电脑挂盘</p>
          <p>专业的助手服务提供商</p>
        </div>
        <div class="footer-section">
          <h4>产品服务</h4>
          <ul>
            <li><router-link to="/introduce">产品介绍</router-link></li>
            <li><router-link to="/download">产品下载</router-link></li>
            <li><router-link to="/agent">代理加盟</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h4>联系我们</h4>
          <p>服务时间：早9点到晚上12点</p>
          <p>支持测试，支持远程协助</p>
          <p>先测试，再开号</p>
        </div>
        <div class="footer-section">
          <h4>技术支持</h4>
          <p>技术在线，实时协助</p>
          <p>专业售后一对一远程处理</p>
          <p>欢迎合作！</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2026 掌柜助手. 保留所有权利.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  margin-top: auto;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 3rem 0 2rem;
}

.footer-section h3 {
  font-size: 24px;
  margin-bottom: 1rem;
  background: linear-gradient(45deg, #3498db, #2980b9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.footer-section h4 {
  font-size: 18px;
  margin-bottom: 1rem;
  color: #3498db;
}

.footer-section p {
  margin-bottom: 0.5rem;
  color: #bdc3c7;
  line-height: 1.6;
}

.footer-section ul {
  list-style: none;
}

.footer-section ul li {
  margin-bottom: 0.5rem;
}

.footer-section ul li a {
  color: #bdc3c7;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-section ul li a:hover {
  color: #3498db;
}

.footer-bottom {
  border-top: 1px solid #34495e;
  padding: 1.5rem 0;
  text-align: center;
  color: #95a5a6;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 2rem 0 1rem;
  }
  
  .footer-section {
    text-align: center;
  }
}
</style>
